import type { Source } from "@tandemdiabetes/sugarmate-api-react-client"
import { SourceType } from "@tandemdiabetes/sugarmate-api-react-client"
import { Dialog } from "@tandemdiabetes/sugarmate-react-components"
import dayjs from "dayjs"
import {
  useState,
  useEffect,
  useRef,
} from "react"
import { DataSourceAlreadyExistsDialogContent } from "./DataSourceAlreadyExistsDialogContent"
import { NoNewReadingsDialogContent } from "./NoNewReadingsDialogContent"

interface Props {
  source?: Source;
}

/*
 * this component handles nesting the warning dialogs so that the dismiss
 * events bubble properly and they are dismissed one at a time
 */
export function WarningDialogs(props: Props) {
  const warningsShowedForSourceRef = useRef<Source["id"] | null>(null)
  const [
    isAlreadyExistsOpen,
    setIsAlreadyExistsOpen,
  ] =
    useState<boolean>(false)

  const { source } = props

  const [
    noNewReadings,
    setNoNewReadings,
  ] = useState<boolean>(false)

  useEffect(
    () => {
    // if the source was created within the last 10 seconds
      if (!source) {
        return
      }

      const isSourceNew = dayjs()
        .subtract(
          10,
          "seconds",
        )
        .isBefore(source.created_at)

      if (!isSourceNew) {
        return
      }

      // only show warning dialgos for each source once
      if (warningsShowedForSourceRef.current === source.id) {
        return
      }

      if (source.already_exists) {
        setIsAlreadyExistsOpen(true)
      }

      if (
        source.last_point_at === null ||
      dayjs().subtract(
        10,
        "minutes",
      )
        .isAfter(source.last_point_at)
      ) {
        setNoNewReadings(true)
      }

      warningsShowedForSourceRef.current = source.id
    },
    [
      source,
      setIsAlreadyExistsOpen,
      setNoNewReadings,
    ],
  )

  const sourceType = source?.source_type

  const isNoNewReadingsOpen =
    noNewReadings &&
    (sourceType === SourceType.Dexcom || sourceType === SourceType.Nightscout)

  return (
    <>
      <Dialog
        open={isNoNewReadingsOpen}
        onOpenChange={setNoNewReadings}
      >
        <NoNewReadingsDialogContent source={props.source}>
          <Dialog
            open={isAlreadyExistsOpen}
            onOpenChange={setIsAlreadyExistsOpen}
          >
            <DataSourceAlreadyExistsDialogContent />
          </Dialog>
        </NoNewReadingsDialogContent>
      </Dialog>
      {!isNoNewReadingsOpen &&
        (sourceType === SourceType.Dexcom ||
          sourceType === SourceType.Nightscout) && (
        <Dialog
          open={isAlreadyExistsOpen}
          onOpenChange={setIsAlreadyExistsOpen}
        >
          <DataSourceAlreadyExistsDialogContent />
        </Dialog>
      )}
    </>
  )
}
